import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import VueSetup from "../../../../contents/docs/integrate/_snippets/vuejs/vue-setup.mdx";
import Tab from "components/Tab";
import CompositionEvents from "../../../../contents/docs/libraries/vue-js/_snippets/composition-events.mdx";
import PluginEvents from "../../../../contents/docs/libraries/vue-js/_snippets/plugin-events.mdx";
import ProvideInjectInstall from "../../../../contents/docs/libraries/vue-js/_snippets/provide-inject-install.mdx";
import PrototypeInstall from "../../../../contents/docs/libraries/vue-js/_snippets/prototype-install.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  DetailPostHogIPs,
  VueSetup,
  Tab,
  CompositionEvents,
  PluginEvents,
  ProvideInjectInstall,
  PrototypeInstall,
  React
};